<style scoped>
.wxchat-container {
    width: 100%;
    z-index: 100;
    left: 0;
    top: 0;
    overflow: hidden;
}
.shadow {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 100;
    width: 100%;
    height: 100%;
    background: #000;
    opacity: 0.2;
}
.window {
    box-shadow: 1px 1px 20px -5px #000;
    width: 100%;
    background: #f5f5f5;
    margin: 0 auto;
    overflow: hidden;
    padding: 0;
    height: 100%;
    position: relative;
    z-index: 101;
}
button {
    border: 0;
    background: none;
    border-radius: 0;
    text-align: center;
}
button {
    outline: none;
}
.w100 {
    width: 100%;
}
.mt5 {
    margin-top: 5px;
}
.mt10 {
    margin-top: 10px;
}
.mt20 {
    margin-top: 20px;
}
.mb10 {
    margin-bottom: 10px;
}
.mb20 {
    margin-bottom: 20px;
}
.fs0 {
    font-size: 0;
}
.title {
    background: #000;
    text-align: center;
    color: #fff;
    width: 100%;
    height: 50px;
    line-height: 50px;
    font-size: 14px;
}
.loading,
.no-more {
    text-align: center;
    color: #b0b0b0;
    line-height: 100px;
}
.no-more {
    line-height: 60px;
}
.pull-right {
    float: right;
}
.link-line {
    text-decoration: underline;
}
.message {
    padding: 10px 15px;
    /* padding-bottom: 50px; */

    background-color: #f5f5f5;
}
.message li {
    margin-bottom: 15px;
    left: 0;
    position: relative;
    display: block;
}
.message .time {
    margin: 10px 0;
    text-align: center;
}
.message .text {
    display: inline-block;
    position: relative;
    padding: 0 10px;
    max-width: calc(100% - 75px - 35px);
    line-height: 1.71;
    font-size: 14px;
    padding: 5px 10px 5px;
    text-align: left;
    /* word-break: break-all; */
    overflow-wrap: break-word;
    background-color: #fff;
    color: #000;
    border-radius: 4px;
    box-shadow: 0px 1px 7px -5px #000;
    min-height: 33px;
    -webkit-user-select: text; /*webkit浏览器*/
    -khtml-user-select: text; /*早期浏览器*/
    -moz-user-select: text; /*火狐*/
    -ms-user-select: text; /*IE10*/
    user-select: text;
}
.message .text:before {
    content: " ";
    position: absolute;
    top: 9px;
    right: 100%;
    border: 6px solid transparent;
    border-right-color: #fff;
}

.contact {
}
.contact-description {
    margin-top: 12px;
    text-align: center;
    font-size: 12px;
    font-weight: 400;
    line-height: 20px;
    color: #999999;
}
.contact-item {
    cursor: pointer;
}
.contact-item-btn {
    color: #397df3;
}
.contact-remark {
    font-size: 12px;
}

.message .tree {
    background: #e6e6e6;
    width: calc(100% - 75px - 135px) !important;
}
.message .tree:before {
    border-right-color: #e6e6e6;
}

.message .tree .treeTitle {
    overflow: hidden;
    -webkit-touch-callout: none; /*系统默认菜单被禁用*/
    -webkit-user-select: none; /*webkit浏览器*/
    -khtml-user-select: none; /*早期浏览器*/
    -moz-user-select: none; /*火狐*/
    -ms-user-select: none; /*IE10*/
    user-select: none;
}
.message .tree .treeTitle .left {
    float: left;
    color: #505050;
}
.message .tree .treeTitle .right {
    float: right;
    color: #3385ff;
    cursor: pointer;
}

.message .tree .listCon {
    background: #fff;
    border: 1px solid #ccc;
    border-top: 0px;
    margin-top: 5px;
    padding-top: 0;
    line-height: 20px;
    overflow: hidden;
    display: none;
}
.message .tree .listCon .item {
    border-top: 1px solid #ccc;
    overflow: hidden;
    padding: 5px 8px 6px;
    color: #3385ff;
}
.message .avatar {
    float: left;
    margin: 0 10px 0 0;
    border-radius: 3px;
}
.message .sendUser {
    margin-bottom: 4px;
}
.message .sendUserName {
    color: #777;
    position: relative;
    top: -2px;
}
.message .self .sendUserName {
}
.message .time > span {
    display: inline-block;
    padding: 2px 14px;
    font-size: 10px;
    color: #fff;
    border-radius: 8px;
    background-color: #dadada;
}
.message .system > span {
    padding: 4px 9px;
    text-align: left;
}
.message .goods {
    min-width: 60%;
    max-width: 300px;
    cursor: pointer;
}
.message .goods .left {
    float: left;
    width: calc(100% - 62px - 10px);
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
}
.message .goods .right {
    float: right;
    display: block;
    width: 60px;
    height: 60px;
    border: 1px solid #ddd;
    border-radius: 5px;
}
.message .self {
    text-align: right;
}
.message .self .avatar {
    float: right;
    margin: 0 0 0 10px;
}

.message .self .text {
    background-color: #9eea6a;
}

.message .self .text:before {
    right: inherit;
    left: 100%;
    border-right-color: transparent;
    border-left-color: #9eea6a;
}
.message .text-image {
    padding: 0;
    line-height: 0;
    border-radius: 5px;
    min-height: 0px;
}
.message .self .text-image::before {
    border-left-color: #fff;
}
.message .text-image img {
    border-radius: 5px;
    cursor: zoom-in;
}

.message .self .goods:before {
    border-left-color: #fff !important;
}
.message .image {
    max-width: 200px;
}
.message .laodingimage {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(5, 5, 5, 0.7);
    color: #fff;
    font-size: 18px;
    text-align: center;
}
.message .laodingimage .laodingimagetext {
    position: absolute;
    top: calc(50% - 15px);
    width: 100%;
    left: 0;
}
img.static-emotion-gif,
img.static-emotion {
    vertical-align: middle !important;
}

.an-move-left {
    left: 0;
    animation: moveLeft 0.7s ease;
    -webkit-animation: moveLeft 0.7s ease;
}
.an-move-right {
    left: 0;
    animation: moveRight 0.7s ease;
    -webkit-animation: moveRight 0.7s ease;
}
.bgnone {
    background: none;
}
@keyframes moveRight {
    0% {
        left: -20px;
        opacity: 0;
    }
    100% {
        left: 0;
        opacity: 1;
    }
}

@-webkit-keyframes moveRight {
    0% {
        left: -20px;
        opacity: 0;
    }
    100% {
        left: 0px;
        opacity: 1;
    }
}
@keyframes moveLeft {
    0% {
        left: 20px;
        opacity: 0;
    }
    100% {
        left: 0px;
        opacity: 1;
    }
}

@-webkit-keyframes moveLeft {
    0% {
        left: 20px;
        opacity: 0;
    }
    100% {
        left: 0px;
        opacity: 1;
    }
}

@media (max-width: 367px) {
    .fzDInfo {
        width: 82%;
    }
}

.event {
    width: 100%;
    text-align: center;
}
.event > .eventText {
    display: inline-block;
    padding: 2px 28px;
    font-size: 10px;
    color: #fff;
    /* border-radius: 8px; */
    background-color: #c7c6c6;
}
.tag {
    width: 100%;
    text-align: center;
}
.tag > .tagText {
    display: inline-block;
    padding: 2px 28px;
    font-size: 12px;
    color: #fff;
    border-radius: 20px;
    background-color: #f56c6c;
    margin: 5px;
}

.transfer-out {
    width: 100%;
    text-align: center;
}
.transfer-out > .transfer-out-con {
    display: inline-block;
    padding: 5px 28px;
    color: #505050;
    /* border-radius: 8px; */
    background-color: #ddd;
    cursor: pointer;
    line-height: 14px;
}
.transfer-out > .transfer-out-con .transfer-out-text {
    vertical-align: middle;
}
.transfer-out > .transfer-out-con .icon {
    width: 18px;
    vertical-align: middle;
}
</style>
<style lang="scss">
.message {
    .avatar {
        float: left;
        margin: 0 10px 0 0;
        border-radius: 3px;
        width: 35px;
        height: 35px;
    }
}
.itemDialog {
    width: 360px;
    .dialog-top {
        overflow: hidden;
        line-height: 0;
        height: 30px;
        .img {
            width: 30px;
            height: 30px;
            float: left;
        }
        .text {
            width: calc(100% - 35px - 8px);
            height: 30px;
            float: left;
            line-height: 30px;
            margin-left: 8px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
        }
    }
    .dialog-bottom {
        margin-top: 8px;
        text-align: left;
        width: 100%;
        overflow: hidden;
        word-break: break-all;
    }
}
</style>

<template>
    <div class="wxchat-container" @contextmenu.prevent>
        <div class="window" id="window-view-container">
            <div class="message">
                <ul v-if="data" style="padding:0;">
                    <li
                        v-for="(message,index) in data"
                        :key="index + '' + message.type"
                        :class="message.type=='receive'?'an-move-right':'an-move-left'"
                    >
                        <div class="event" v-if="message.msgType == 'event'">
                            <!-- 满意度评价 -->
                            <!-- this.$store.state.user.myRole == "admin" || this.$store.state.user.myRole == "manager" -->
                            <div v-if="message.type == 'client_appraisal' && $router.history.current.fullPath=='/workReport/workQualityDetail'" 
                                class="evaluation_mes"
                                @click.stop="openEvaluationDialog(message.description)"
                            >
                                <span v-if="isToday(message.sendTime)">
                                    <span>{{parseInt(message.sendTime) | formatterDate("今天 HH:mm:ss")}}</span>
                                </span>
                                <span v-else>
                                    <span>{{parseInt(message.sendTime) | formatterDate("yyyy-MM-dd HH:mm:ss")}}</span>
                                </span>
                                <span style="margin-left:10px;">客户提交满意度评价</span>
                            </div>
                            <!-- 普通时间节点 -->
                            <div v-else class="eventText">
                                <span v-if="isToday(message.sendTime)">
                                    <span>{{parseInt(message.sendTime) | formatterDate("今天 HH:mm:ss")}}</span>
                                </span>
                                <span v-else>
                                    <span>{{parseInt(message.sendTime) | formatterDate("yyyy-MM-dd HH:mm:ss")}}</span>
                                </span>
                                <span style="margin-left:10px;">{{message.content}}</span>
                            </div>
                        </div>

                        <!-- 转出 -->
                        <div class="transfer-out" v-else-if="message.msgType == 'transfer_out'">
                            <div class="transfer-out-con" @click="clickTransferOut(message)">
                                <span class="transfer-out-text">{{message.content}}</span>

                                <img
                                    v-if="message.description"
                                    class="icon"
                                    src="../../assets/images/icon/file.svg"
                                    alt
                                />
                            </div>
                        </div>

                        <!-- 转入 -->
                        <div class="transfer-out" v-else-if="message.msgType == 'transfer_in'">
                            <div class="transfer-out-con" @click="clickTransferOut(message)">
                                <span class="transfer-out-text">{{message.content}}</span>

                                <img
                                    v-if="message.description"
                                    class="icon"
                                    src="../../assets/images/icon/file.svg"
                                    alt
                                />
                            </div>
                        </div>

                        <div v-else>
                            <div v-if="isShowTime(index)">
                                <p class="time" v-if="isToday(message.sendTime)">
                                    <span>{{parseInt(message.sendTime) | formatterDate("今天 HH:mm:ss")}}</span>
                                </p>

                                <p class="time" v-else>
                                    <span>{{parseInt(message.sendTime) | formatterDate("yyyy-MM-dd HH:mm:ss")}}</span>
                                </p>
                            </div>

                            <v-json-type v-if="message.msgType == 'cardExt'" :json="message.extData"></v-json-type>

                            <div v-else :class="'main' + (message.type=='receive'?' self':'')">
                                <div class="sendUser">
                                    <div v-if="!showPopover">
                                        <img
                                            v-if="message.sendUserAvatar"
                                            class="avatar"
                                            :src="message.sendUserAvatar"
                                            alt
                                        />
                                        <img
                                            v-else
                                            class="avatar"
                                            src="../../assets/images/avatar.png"
                                            alt
                                        />
                                    </div>

                                    <div v-else>
                                        <el-popover
                                            transition="none"
                                            :offset="500"
                                            placement="right-end"
                                            trigger="click"
                                        >
                                            <div slot="reference" class="img">
                                                <img
                                                    style="cursor: pointer;"
                                                    v-if="message.sendUserAvatar"
                                                    class="avatar"
                                                    :src="message.sendUserAvatar"
                                                    alt
                                                />
                                                <img
                                                    style="cursor: pointer;"
                                                    v-else
                                                    class="avatar"
                                                    src="../../assets/images/avatar.png"
                                                    alt
                                                />
                                            </div>

                                            <div class="itemDialog">
                                                <div class="dialog-top">
                                                    <img
                                                        v-if="message.sendUserAvatar"
                                                        class="img"
                                                        width="35"
                                                        height="35"
                                                        alt
                                                        :src="message.sendUserAvatar"
                                                    />
                                                    <img
                                                        v-else
                                                        class="img"
                                                        width="35"
                                                        height="35"
                                                        alt
                                                        src="../../assets/images/avatar.png"
                                                    />

                                                    <div class="text">
                                                        <span
                                                            v-if="message.sendUserName"
                                                        >{{message.sendUserName}}</span>
                                                        <span v-else>匿名用户</span>
                                                    </div>
                                                </div>
                                                <div class="dialog-bottom">
                                                    <span>访客标识：</span>
                                                    <span>{{message.sendUserId}}</span>
                                                </div>
                                                <div v-if="message.device" class="dialog-bottom">
                                                    <span>设备信息：</span>
                                                    <span>{{message.device}}</span>
                                                </div>
                                                <div v-if="message.extraData" class="dialog-bottom">
                                                    <span>其他信息：</span>
                                                    <span>{{message.extraData}}</span>
                                                </div>
                                            </div>
                                        </el-popover>
                                    </div>

                                    <span class="sendUserName">{{message.sendUserName}}</span>
                                </div>

                                <!-- 送达 -->
                                <!-- <span v-if="message.direction == 2 && message.succeed" style="font-size:10px;color:#bbb;position:relative;top:10px;">送达</span> -->
                                <!-- 未送达 -->
                                <!-- <span v-if="message.direction == 2 && !message.succeed" style="font-size:10px;color:#bbb;position:relative;top:10px;"><van-loading style="display:inline-block"  type="spinner" size="10px" color="black" /></span> -->
                                <!-- 文本 -->
                                <div
                                    @contextmenu.prevent.stop="openMenu($event,message)"
                                    class="text"
                                    v-if="message.msgType=='text'"
                                    v-html="$options.filters.emoji(message.content)"
                                ></div>
                                <!-- 图片 -->
                                <div class="text text-image" v-else-if="message.msgType=='image'">
                                    <img
                                        @contextmenu.prevent.stop="openMenuImg($event,message,index)"
                                        @click="clickImg(index)"
                                        @load="imgLoad()"
                                        :src="message.imgUrl"
                                        class="image"
                                        alt="聊天图片"
                                    />
                                </div>
                                <!-- 加载中的图片 -->
                                <div
                                    class="text text-image"
                                    v-else-if="message.msgType=='laodingimage'"
                                >
                                    <div class="laodingimage">
                                        <span class="laodingimagetext">图片发送中...</span>
                                    </div>
                                    <img
                                        @load="imgLoad()"
                                        :imgId="message.imgId"
                                        :src="message.imgUrl"
                                        class="image"
                                        alt="[图片加载失败]"
                                    />
                                </div>

                                <!-- 图文链接 -->
                                <div
                                    @contextmenu.prevent.stop="openMenuTag($event,message)"
                                    class="text goods"
                                    style="background:#fff;border:1px solid #eee;"
                                    v-else-if="message.msgType=='card'"
                                    @click="linkCard(message.forwardUrl)"
                                >
                                    <div>{{message.description}}</div>
                                    <div style="overflow: hidden;margin-bottom:5px;">
                                        <div
                                            class="left"
                                            style="font-size:12px;color:#999;"
                                        >{{message.content}}</div>
                                        <img class="right" :src="message.imgUrl" alt />
                                    </div>
                                </div>

                                <!-- 自动回复的列表 -->
                                <div
                                    @contextmenu.prevent.stop="openMenuTag($event,message)"
                                    class="text tree"
                                    v-else-if="message.msgType=='tree'"
                                >
                                    <div class="treeTitle">
                                        <div class="left">常见问题</div>
                                        <div class="right" @click="showTreeList">
                                            <i
                                                style="position:relative;"
                                                class="el-icon-arrow-down"
                                            ></i>
                                            <span>展开</span>
                                        </div>
                                    </div>
                                    <div class="listCon">
                                        <div
                                            class="item"
                                            v-for="(item,index) in message.content"
                                            :key="'tree' + index"
                                        >
                                            <div class="itemText">{{item.title}}</div>
                                        </div>
                                    </div>
                                </div>
                                  <!-- 自动回复 -->
                                <div
                                    class="contact"
                                    v-else-if="message.msgType == 'contact'"
                                >
                                    <div class="text">
                                        <div class="contact-content">
                                            {{ message.content }}
                                        </div>
                                        <div
                                            v-if="message.mobile"
                                            @click="copy(message.mobile)"
                                            class="contact-item"
                                        >
                                            <span>电话：</span>
                                            <span class="contact-item-btn">{{
                                                message.mobile
                                            }}</span>
                                        </div>
                                        <div
                                            v-if="message.wxAccount"
                                            @click="copy(message.wxAccount)"
                                            class="contact-item"
                                        >
                                            <span>微信：</span>
                                            <span class="contact-item-btn">{{
                                                message.wxAccount
                                            }}</span>
                                        </div>
                                        <div class="contact-remark">
                                            点击手机号、微信号可复制
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>

                        <div class="tag">
                            <div v-for="tag in message.tags" :key="tag.id" class="tagText">
                                <span v-if="isToday(tag.crtTime)">
                                    <span>{{parseInt(tag.crtTime) | formatterDate("今天 HH:mm:ss")}}</span>
                                </span>
                                <span v-else>
                                    <span>{{parseInt(tag.crtTime) | formatterDate("yyyy-MM-dd HH:mm:ss")}}</span>
                                </span>
                                <span style="margin-left:10px;">{{tag.tagName}}</span>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>

        <el-dialog
            :append-to-body="true"
            title="跨组转接备注"
            :visible.sync="showRoleListDescription"
            :before-close="closeRoleListDescription"
            class="roleListDescription-dialog"
            :close-on-click-modal="false"
        >
            <vue-scroll :ops="ops2">
                <div @click="clickRTF" v-html="transferOutDescription" class="ql-editor"></div>
            </vue-scroll>
        </el-dialog>

        <!-- 客户评价dialog -->
        <el-dialog
            width="400px"
            :modal="false"
            :visible.sync="evaluationShow"
            class="evaluation_dialog">
            <!-- 标题 -->
                <div class="evalution_title">客户满意度评价</div>
                <!-- 是否解决 -->
                <div class="solve_box">
                    <div class="btn btn_on" style="background: #0098FF; color: #fff;" v-if="descriptionInfo.solved">
                        <img src="../../assets/images/like_on.png" class="solve_img" />
                        已解决
                    </div>
                    <div class="btn btn_off" style="color: #C1C1C1;" v-else>
                        <img src="../../assets/images/unlike_off.png" class="solve_img" />
                        未解决
                    </div>
                </div>
                <!-- 评星 -->
                <div class="rate_box">
                    <div class="star_box">
                        <img class="star" src="../../assets/images/star_on.png" v-for="(item,index) in descriptionInfo.star" :key="index+'like'">
                        <img class="star" src="../../assets/images/star_off.png" v-for="index in 4-descriptionInfo.star" :key="index+'unlike'">
                    </div>
                    <span v-if="descriptionInfo.star == 4" style="color: #faba4a;">非常满意</span>
                    <span v-else-if="descriptionInfo.star == 3" style="color: #faba4a;">满意</span>
                    <span v-else-if="descriptionInfo.star == 2" style="color: #505050;">一般</span>
                    <span v-else-if="descriptionInfo.star == 1" style="color: #505050;">不满意</span>
                </div>
                <!-- 建议 -->
                <textarea v-model="descriptionInfo.msg" disabled cols="30" rows="10" class="suggest" ></textarea>
        </el-dialog>

    </div>
</template>

<script>
import jsonType from "./jsonType/index"

export default {
    name: "wxChat",

    components: {
        'v-json-type':jsonType
    },

    props: {
        data: {
            type: Array,
            required: true
        },
        hiddenTime: {
            type: Boolean,
            required: false
        },
        showPopover: {
            type: Boolean,
            required: false
        },
        openCreat: {
            type: Function,
            required: false
        }
    },

    data() {
        return {
            isUpperLaoding: false,
            isUnderLaoding: false,

            isRefreshedAll: false,
            isLoadedAll: false,

            minHeight: 700,
            dataArray: [],

            ops2: {
                vuescroll: {
                    mode: "native"
                },
                sizeStrategy: "number",
                scrollPanel: {
                    // 是否禁止x或y方向上的滚动
                    scrollingX: false,
                    scrollingY: true
                },
                scrollContent: {},
                vRail: {}
            },

            // 跨组转接备注
            showRoleListDescription: false,
            transferOutDescription: "",
            // 客户评价开关
            evaluationShow: false,
            descriptionInfo: {
                star: 4,
            },
        };
    },

    created() {
        this.initData();
    },
    mounted() {
        //document.getElementsByTagName('body')[0].scrollTop=0;
        this.minHeight = document.getElementById(
            "window-view-container"
        ).offsetHeight;
        // this.maxHeight = document.getElementById('window-view-container').offsetHeight;
    },

    methods: {
        copy(text){
            let that = this;
            that.$copy(text, () => {
                that.$message({
                    message: "复制成功",
                    type: "success"
                });
            });
        },
        isToday(time) {
            let d = new Date(time).toDateString() === new Date().toDateString();
            if (d) {
                return true;
            } else {
                return false;
            }
        },
        showTreeList(e) {
            let parent = e.currentTarget.parentNode.parentNode;
            let dom = parent.getElementsByClassName("listCon")[0];

            if (dom.style.display == "none" || !dom.style.display) {
                dom.style.display = "block";
            } else {
                dom.style.display = "none";
            }
        },
        openMenuTag(e, data) {
            let that = this;
            let biaoqian = this.$route.name == "service" ? "打标签" : "";

            this.$openMenu(e, {
                array: [
                    {
                        text: biaoqian
                    },
                    {
                        text: that.$route.name == 'service' || 
                            that.$route.name == 'overChat' ||
                            that.$route.name == 'chat'  ||
                            that.$route.name == 'workQualityDetail'||
                            that.$route.name == 'message'
                            ? `创建工单` : ``
                    }
                ],
                click(item, index) {
                    if (index == 0) {
                        that.$emit("openMessageTag", data);
                    } else if (index == 1) {
                        // console.log(data,'menuTag创建工单')
                        that.$emit('openCreat','resource',data);
                    }
                }
            });
        },
        openMenu(e, data) {
            let that = this;

            let seleText = window.getSelection().toString();
            let color = window.getSelection().toString() ? "" : "#888";

            let biaoqian = (this.$route.name == "service" || this.$route.name == "window") ? "打标签" : "";

            this.$openMenu(e, {
                array: [
                    {
                        text: `复制选中文字(${seleText})`,
                        color: color
                    },
                    {
                        text: `复制整条信息`
                    },
                    {
                        text: biaoqian
                    },
                    {
                        text: that.$route.name == 'service' || 
                            that.$route.name == 'overChat' ||
                            that.$route.name == 'chat'  ||
                            that.$route.name == 'workQualityDetail'||
                            that.$route.name == 'message'
                            ? `创建工单` : ``
                    }
                ],
                click(item, index) {
                    if (index == 0) {
                        // 复制选中
                        that.$copy(seleText, () => {
                            that.$message({
                                message: "复制成功",
                                type: "success"
                            });
                        });
                    } else if (index == 1) {
                        //   复制整条
                        that.$copy(data.content, () => {
                            that.$message({
                                message: "复制成功",
                                type: "success"
                            });
                        });
                    } else if (index == 2) {
                        that.$emit("openMessageTag", data);
                    } else if (index == 3) {
                        // console.log(that.$route,'menu创建工单')
                        that.$emit('openCreat','resource',data);
                    }
                }
            });
        },
        openMenuImg(e, data, imgIndex) {
            let that = this;

            // let seleText = window.getSelection().toString()
            // let color =  window.getSelection().toString()?'':'#888'

            let biaoqian = this.$route.name == "service" ? "打标签" : "";

            this.$openMenu(e, {
                array: [
                    {
                        text: `放大`
                    },
                    {
                        text: `新页面打开图片`
                    },
                    {
                        text: biaoqian
                    },
                    {
                        text: that.$route.name == 'service' || 
                            that.$route.name == 'overChat' ||
                            that.$route.name == 'chat'  ||
                            that.$route.name == 'workQualityDetail'||
                            that.$route.name == 'message'
                            ? `创建工单` : ``
                    }
                ],
                click(item, index) {
                    if (index == 0) {
                        // 放大
                        that.clickImg(imgIndex);
                    } else if (index == 1) {
                        // console.log(window.open)
                        window.open(data.imgUrl);
                    } else if (index == 2) {
                        that.$emit("openMessageTag", data);
                    } else if (index == 3) {
                        // console.log(data,'menuImg创建工单')
                        that.$emit('openCreat','resource',data);
                    }
                }
            });
        },
        isShowTime(index) {
            // 判断是否显示time
            if (!this.hiddenTime) {
                return true;
            }
            // 第一条必定显示
            if (index == 0) {
                return true;
            } else {
                // 第二条判断3分钟
                let time =
                    this.data[index].sendTime - this.data[index - 1].sendTime;
                // 三分钟
                let dTime = 1000 * 60 * 3;

                if (time >= dTime) {
                    return true;
                } else {
                    return false;
                }
            }
        },
        clickImg(e) {
            let arr = [];
            let j = 0;
            if (this.data) {
                for (let i = 0; i < this.data.length; i++) {
                    if (this.data[i].msgType == "image") {
                        arr.push(this.data[i].imgUrl);
                        if (i <= e) {
                            j++;
                        }
                    }
                }
            }
            let obj = {
                list: arr,
                index: j - 1
            };
            this.$previewImg(obj);
        },
        link(url) {
            if (url) {
                window.location.href = url;
            }
        },
        linkCard(url) {
            if (url) {
                if (url.substr(0, 4) == "http") {
                    window.open(url);
                }
            }
        },
        // clickTransferOut(item){
        //     if(item.description){
        //         this.$emit("clickTransferOut",item);
        //     }
        // },
        // 跨组转接备注
        clickTransferOut(item) {
            let id = item.description;
            if (!id) {
                return;
            }
            this.$reqPost(`/api/transfer/${id}/get`, {}).then(
                res => {
                    if (res.data.returnData.description) {
                        this.transferOutDescription =
                            res.data.returnData.description;
                        this.showRoleListDescription = true;
                    } else {
                        this.$message.error("无备注信息");
                    }
                },
                err => {}
            );
        },
        closeRoleListDescription() {
            this.showRoleListDescription = false;
            this.transferOutDescription = "";
        },
        clickRTF(e) {
            if (e.target.tagName == "IMG" && e.target.getAttribute("src")) {
                let arr = [];
                arr.push(e.target.getAttribute("src"));
                let obj = {
                    list: arr,
                    index: 0
                };
                this.$previewImg(obj);
            }
        },
        imgLoad() {
            this.$emit("imgLoad");
        },
        initData() {
            this.dataArray = this.dataArray.concat(this.data);
        },
        openEvaluationDialog(description) {
            console.log('打开评价界面')
            this.evaluationShow = true;
            this.descriptionInfo = JSON.parse(description)
        },
    }
};
</script>

<style lang="scss">
.roleListDescription-dialog .el-dialog {
    width: 800px;
    height: 90vh;
    overflow: hidden;
    margin-top: 5vh !important;
    margin-bottom: 5vh !important;
    .el-dialog__body {
        padding: 0 20px;
        height: calc(100% - 54px);
    }
}
//新增评价dialog
.evaluation_mes{
    cursor: pointer;
    display: inline-block;
    padding: 4px 24px;
    font-size: 10px;
    color: #fff;
    border-radius: 8px;
    background-color: rgb(245, 108, 108);
}
.evaluation_dialog{
    .el-dialog{
        width: 400px;
        height: 520px !important;
        margin-top: 10vh !important;
    }
    .evalution_title {
        font-size: 22px;
        width: 100%;
        text-align: center;
        margin-top: 30px;
    }
    .solve_box {
        width: 100%;
        margin-top: 50px;
        display: flex;
        justify-content: center;
        .btn {
            width: 130px;
            height: 40px;
            font-size: 18px;
            border-radius: 5px;
            display: flex;
            justify-content: center;
            align-items: center;
            margin: 0 20px;
            .solve_img{
                width: 25px;
                height: 22px;
                margin-right: 10px;
            }
        }
        .btn_on {
            color: #fff;
            border: 1px solid #0098FF;
            background: #0098FF;
        }
        .btn_off {
            color: #C1C1C1;
            border: 1px solid #C1C1C1;
        }
    }
    .rate_box{
        display: flex;
        flex-direction: column; 
        justify-content: center;
        align-items: center;
        margin-top: 30px;
        .star_box{
            .star{
                width: 48px;
                height: 48px;
                margin: 0 5px;
            }
        }
        span{
            font-size: 18px;
            margin-top: 20px;
        }
    }
    .suggest{
        width: 338px;
        height: 120px;
        border: 1px solid #c1c1c1;
        margin: 50px 0 0 30px;
        padding: 15px;
        resize: none;
    }
    .subBtn{
        width: 190px;
        height: 40px;
        font-size: 18px;
        border-radius: 5px;
        color: #fff;
        text-align: center;
        line-height: 40px;
        border: 1px solid #0098FF;
        background: #0098FF;
        margin-top: 55px;
        margin-left: calc(50% - 95px);
    } 
}
</style>



// WEBPACK FOOTER //
// src/vue/components/wxChat.vue